package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Clock
import kotlinx.serialization.Serializable


@Serializable
enum class PropertyType (val title: kotlin.String) {
    String("Строка"),
    Int("Целое число"),
    Float("Число с точкой"),
    Date("Формат даты:"),
    Bool("Да / Нет"),
}

@Serializable
data class Property(
    val id: String,
    val store: String,
    val name: String,
    val variable: String,
    val type: PropertyType = PropertyType.String,
    val multiValued: Boolean = false
)

fun List<Property>.generateDefaultContent(): Map<String, Any> {
    return associate { property ->
        property.variable to when (property.type) {
            PropertyType.String -> ""
            PropertyType.Int -> 0
            PropertyType.Float -> 0.0f
            PropertyType.Date -> Clock.System.now()
            PropertyType.Bool -> false
        }.let { if (property.multiValued) listOf(it) else it }
    }
}
@Serializable
data class SubscribersPropertyFilter(
    val _id: String,
    val values: List<String>
)
